<template>
  <div class="order-detail">
    <div class="container">
      <div class="breadcrumb">
        <router-link to="/workbench/procurementOrder" class="link"
          >代购订单</router-link
        >
        <span class="link">></span>
        <span class="link"> 订单详情 </span>
      </div>
      <div class="step-box flex align-center" v-if="detail.status != 1">
        <div class="step-item" :class="[step == 1 ? 'active' : '']">
          1.待接单
        </div>
        <img :src="stepOneIcon" class="step-icon" />
        <div class="step-item" :class="[step == 2 ? 'active' : '']">
          2.发货处理
        </div>
        <img :src="stepTwoIcon" class="step-icon" />
        <div class="step-item" :class="[step == 3 ? 'active' : '']">
          3.完成发货
        </div>
      </div>
      <div class="bg-white margin-top-20 padding-20">
        <div class="order-container">
          <!-- 订单头部 -->
          <div class="order-header">
            <div class="order-title-wrap">
              <div>
                <div class="order-title">{{ detail.material_name }}</div>
              </div>
              <span class="status-tag">{{ detail.status_name }}</span>
              <!-- <span class="countdown-text"
                >派单剩余处理时间:2小时28分(超时自动拒绝)</span
              > -->
            </div>
            <div class="online-contact" @click="showChat">
              <img
                src="../../assets/images/procurement/ico_chat.png"
                style="width: 22px; height: 22px"
              />
              在线沟通
            </div>
          </div>
          <div class="order-id">订单编号：{{ detail.order_no }}</div>

          <!-- 修正后的订单信息表格 -->
          <table class="order-info-table">
            <tr>
              <td>
                <div class="param-label">派单时间</div>
                <div class="param-value">{{ detail.assign_time }}</div>
              </td>
              <td>
                <div class="param-label">订单类型</div>
                <div class="param-value">
                  {{ detail.material_type == 1 ? "面料采购" : "辅料采购" }}
                </div>
              </td>
              <td>
                <div class="param-label">需求数量</div>
                <div class="param-value">
                  {{ detail.required_quantity }}{{ detail.material_unit }}
                </div>
              </td>
              <td>
                <div class="param-label">寄样地址</div>
                <div class="param-value">{{ setting.contact_address }}</div>
              </td>
              <td>
                <div class="param-label">交付周期</div>
                <div class="param-value">{{ detail.date_required }}之前</div>
              </td>
            </tr>
          </table>

          <!-- 操作按钮区域 -->
          <div class="order-actions" v-if="step == 1">
            <div>
              <button class="btn btn-reject" @click="refuseOrder">拒绝接单</button>
              <button class="btn btn-accept" @click="acceptOrder">我要接单</button>
            </div>
            <div class="agreement-text">
              接单即表示您已阅读并同意
              <span
                style="color: #0d99ff"
                @click="onServiceRuleClick('procurementAssign')"
                >《面辅料代货接单协议》</span
              >
            </div>
          </div>
          <div class="order-sample-box">
            <div class="flex align-center justify-between">
              <div class="marrgin-left-10">
                <div class="title-line">
                  <span>报价寄样信息</span>
                  <span style="color: #666666; font-size: 14px"
                    >(可多次添加)</span
                  >
                  <span style="color: #ff5967; font-size: 14px">*</span>
                  <!-- <span
                    style="color: #0066ff; font-size: 14px; margin-left: 10px"
                    >查看寄样地址</span
                  > -->
                </div>
                <div class="text-999 text-13 margin-top-10">
                  请根据提示详细填写相关信息，并根据需求寄出商品小样
                </div>
              </div>
              <div
                class="add-sample"
                @click="showDelivery(true)"
                v-if="detail.status != 1"
              >
                +添加报价寄样记录
              </div>
            </div>
          </div>
          <div class="order-sample-empty" v-if="detail.sample.length == 0">
            <img
              src="../../assets/images/procurement/image-empty.png"
              class="empty-img"
            />
            <div class="text-999">
              暂无报价寄样记录,请尽快完成报价信息并寄出样品~
            </div>
          </div>
          <div class="list-container" v-if="detail.sample.length > 0">
            <table class="fabric-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>档口+实物照片</th>
                  <th>单价(元/{{ detail.material_unit }})</th>
                  <th>起订量({{ detail.material_unit }})</th>
                  <th>采购周期(大货)</th>
                  <th>寄样时间</th>
                  <th>物流信息</th>
                </tr>
              </thead>
              <tbody>
                <!-- 第一行数据 -->
                <tr
                  class="w100"
                  v-for="(item, k) in detail.sample"
                  :key="item.id + 'sample'"
                >
                  <td data-label="序号">{{ k + 1 }}</td>
                  <td data-label="档口+实物照片">
                    <div class="fabric-img-box">
                      <img
                        :src="item.image_list[0].url"
                        class="fabric-img"
                        @click="showImage(item.image_list)"
                      />
                      <div class="img-count">
                        {{ item.image_list.length }}张
                      </div>
                    </div>
                  </td>
                  <td data-label="单价(元/米)">
                    ¥{{ item.price }}/{{ detail.material_unit }}
                  </td>
                  <td data-label="起订量(米)">{{ item.min_quantity }}/</td>
                  <td data-label="采购周期(大货)">{{ item.cycle }}</td>
                  <td data-label="寄样时间">{{ item.delivery_time }}</td>
                  <td data-label="物流信息">
                    {{ item.logistics_name }}<br />{{ item.logistics_no }}
                  </td>
                </tr>
                <!-- 第一行备注 -->
                <tr
                  class="remark-row"
                  v-for="(item, kk) in detail.sample"
                  :key="kk"
                >
                  <td colspan="7" data-label="备注说明" v-if="item.remark">
                    {{ item.remark }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="delivery-info padding-20 bg-white">
        <div class="flex align-center">
          <img
            src="../../assets/images/procurement/ico_truck.png"
            class="ico-truck"
          />
          <span>发大货操作</span>
          <span style="color: #ff5967; font-size: 14px">*</span>
          <!-- <span style="color: #0066ff; font-size: 14px; margin-left: 10px"
            >查看寄大货地址</span
          > -->
        </div>
        <div class="text-999 text-13 margin-top-5">
          客户确认小样及报价都通过后，您可以安排发送大货
        </div>
        <template>
          <div class="order-sample-empty" v-if="detail.status == 2">
            <img
              src="../../assets/images/procurement/image-wait.png"
              class="empty-img"
            />
            <div class="text-999">等待客户确认样品后进行发大货</div>
          </div>
          <div
            class="send-delivery"
            @click="showDelivery(false)"
            v-if="detail.status == 2"
          >
            发大货
          </div>
        </template>
        <template v-if="[3, 4, 5].includes(detail.status)">
          <div class="delivery-big-info">
            <!-- 左侧图片区域 -->
            <div
              class="img-container"
              v-if="detail.image_list.length > 0"
              @click="showImage(detail.image_list)"
            >
              <img :src="detail.image_list[0].url" />
              <div class="img-count">{{ detail.image_list.length }}张</div>
            </div>

            <!-- 右侧信息表格 -->
            <div class="info-container">
              <table class="info-table">
                <tr>
                  <td class="bg-F9FAFC text-center">
                    单价(元/{{ detail.material_unit }})
                  </td>
                  <td class="margin-left-10">{{ detail.price }}</td>
                  <td class="bg-F9FAFC text-center">快递公司</td>
                  <td class="margin-left-10">{{ detail.logistics_name }}</td>
                </tr>
                <tr>
                  <td class="bg-F9FAFC text-center">
                    大货数量({{ detail.material_unit }})
                  </td>
                  <td class="margin-left-10">
                    {{ detail.order_quantity }}{{ detail.material_unit }}
                  </td>
                  <td class="bg-F9FAFC text-center">快递单号</td>
                  <td class="margin-left-10">{{ detail.logistics_no }}</td>
                </tr>
                <tr>
                  <td class="bg-F9FAFC text-center">发货日期</td>
                  <td colspan="3" class="margin-left-10">
                    {{ detail.delivery_time }}
                  </td>
                </tr>
                <tr>
                  <td class="bg-F9FAFC text-center">备注说明</td>
                  <td colspan="3" class="remark-cell margin-left-10">
                    {{ detail.order_remark }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </template>
      </div>
      <div class="bg-white margin-top-20 padding-20">
        <div class="tabs">
          <div
            class="tab-item flex align-center"
            :class="[currTab == 1 ? 'active' : '']"
            @click="onTabClick(1)"
          >
            <img src="../../assets/images/patternMaker/ico_detailed.png" />
            <span class="margin-left-10">需求详情</span>
          </div>
          <div
            class="tab-item flex align-center"
            :class="[currTab == 2 ? 'active' : '']"
            @click="onTabClick(2)"
          >
            <img src="../../assets/images/patternMaker/ico_link.png" />
            <span class="margin-left-10">资料附件</span>
          </div>
        </div>
        <template v-if="currTab == 1">
          <div class="detail-container">
            <!-- 左侧面料图片 -->
            <div class="fabric-image" v-if="detail.material_image">
              <img :src="detail.material_image" v-viewer />
            </div>

            <!-- 右侧面料详情 -->
            <div class="fabric-details">
              <table class="params-table">
                <tr>
                  <td>
                    <span class="param-label">面料名称</span>
                    <span class="param-value">{{ detail.material_name }}</span>
                  </td>
                  <td>
                    <span class="param-label">面料编码</span>
                    <span class="param-value">{{ detail.material_code }}</span>
                  </td>
                  <td>
                    <span class="param-label">面料成分</span>
                    <span class="param-value">{{ detail.component }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="param-label">面料幅宽</span>
                    <span class="param-value">{{ detail.width_wide }}</span>
                  </td>
                  <td>
                    <span class="param-label">面料克重</span>
                    <span class="param-value">{{ detail.weight }}</span>
                  </td>
                  <td>
                    <span class="param-label">需求颜色</span>
                    <span class="param-value">{{ detail.material_color }}</span>
                  </td>
                </tr>
              </table>

              <!-- 使用说明部分 -->
              <div class="usage-section">
                <span class="usage-title">使用说明：</span>
                <p class="usage-content">
                  {{ detail.use_desc }}
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="title-line margin-top-30">订单备注：</div>
          <div class="desc">
            {{ detail.use_desc }}
          </div> -->
        </template>
        <template v-if="currTab == 2">
          <div class="title-line">附件：</div>
          <div class="margin-top-20">
            <div
              class="file-item flex align-center justify-between"
              v-for="(v, index) in detail.material_file"
              :key="index"
            >
              <div class="flex align-center">
                <img :src="util.get_image_icon(v.path)" class="icon-doc" />
                <span class="margin-left-10">{{ v.name }}</span>
              </div>
              <div class="flex align-center cursor" @click="downloadFile(v)">
                <img
                  src="../../assets/images/patternMaker/download.png"
                  class="download-img"
                />
                <span class="download">下载</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <popup
      :show.sync="is_popup_show"
      width="680px"
      height="520px"
      @on-close="is_popup_show = false"
    >
      <div class="agree-content">
        <div v-html="setting[agree_type]"></div>
      </div>
    </popup>
    <AcceptOrder ref="AcceptOrder" @confirm="getDetail"></AcceptOrder>
    <RefuseOrder ref="RefuseOrder" @confirm="getDetail"></RefuseOrder>
    <Delivery ref="Delivery" @confirm="getDetail"></Delivery>
    <Chat ref="chat"></Chat>
  </div>
</template>

<script>
import { GetOrderDetail } from "@/api/procurement.js";
import Popup from "@/components/Popup";
import util from "@/utils/util";
import AcceptOrder from "./components/Accept";
import Delivery from "./components/Delivery";
import RefuseOrder from "./components/Refuse";

import { mapState } from "vuex";

export default {
  name: "OrderCenter",
  components: {
    AcceptOrder,
    RefuseOrder,
    Delivery,
    Popup,
  },
  data() {
    return {
      detail: {
        status: -1,
        image_list: [],
        sample: [],
      },
      uuid: "",
      currTab: 1,
      util,
      is_popup_show: false,
      agree_type: "",
    };
  },
  watch: {},
  computed: {
    ...mapState(["setting"]),
    step() {
      if (this.detail.status == 0) {
        return 1;
      }
      if (this.detail.status == 2) {
        return 2;
      }
      return 3;
    },
    stepOneIcon() {
      if (this.step == 1) {
        return require("@/assets/images/procurement/step-icon-left-active.png");
      }
      if (this.step == 2) {
        return require("@/assets/images/procurement/step-icon-right-active.png");
      }
      return require("@/assets/images/procurement/step-icon.png");
    },
    stepTwoIcon() {
      if (this.step == 2) {
        return require("@/assets/images/procurement/step-icon-left-active.png");
      }
      if (this.step == 3) {
        return require("@/assets/images/procurement/step-icon-right-active.png");
      }
      return require("@/assets/images/procurement/step-icon.png");
    },
  },
  mounted() {
    const { uuid } = this.$route.query;
    this.uuid = uuid;
    this.getDetail();
  },
  methods: {
    showImage(image_list) {
      let images = image_list.map((i) => i.url);
      this.$viewerApi({
        images,
      });
    },
    onServiceRuleClick(type) {
      this.agree_type = type;
      this.is_popup_show = true;
    },
    acceptOrder() {
      this.$refs.AcceptOrder.showModal(this.detail);
    },
    refuseOrder() {
      this.$refs.RefuseOrder.showModal(this.detail);
    },
    showDelivery(is_sample) {
      this.$refs.Delivery.showModal(is_sample, this.detail);
    },
    showChat(v) {
      this.$refs.chat.showChat();
    },
    async getDetail() {
      return GetOrderDetail({
        uuid: this.uuid,
      })
        .then((response) => {
          this.detail = response.data;
        })
        .catch((err) => {
          this.$layer.msg(err.msg);
        });
    },
    onTabClick(index) {
      this.currTab = index;
    },
    downloadFile(file) {
      console.log('file',file);
      if (!file.url) {
        this.$layer.msg("文件地址不存在");
        return;
      }
      const url = file.url;
      const filename = file.name || url.split("/").pop() || "download";
      const loading = this.$layer.loading("下载中...");
      fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error("下载失败");
          return res.blob();
        })
        .then((blob) => {
          this.$layer.close(loading);
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
          this.$layer.msg("下载成功");
        })
        .catch(() => {
          this.$layer.close(loading);
          this.$layer.msg("下载失败，请重试");
        });
    },
    oc(v) {
      return [v.status_text];
    },
  },
};
</script>

<style lang="scss" scoped>
.order-detail {
  background-color: #f8f9fb;

  .container {
    height: 100%;
    width: 1236px;
    margin: auto;
    padding-bottom: 70px;

    .breadcrumb {
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
      text-align: left;

      .link:last-child {
        line-height: 29px;
        color: #333333;
      }

      .link {
        margin-right: 10px;
        color: #999999;
      }
    }
    .step-box {
      width: 100%;
      height: 32px;
      .step-item {
        background: #ebedf0;
        width: calc((100% - 34px) / 3);
        height: 32px;
        line-height: 32px;
        font-weight: 400;
        font-size: 13px;
        color: #333333;
        padding-left: 23px;
        &.active {
          background: rgba(255, 89, 103, 0.1);
          font-weight: bold;
          font-size: 13px;
          color: #ff5967;
        }
      }
      .step-icon {
        width: 17px;
        height: 32px;
      }
    }

    .title-line {
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      margin-top: 24px;
      line-height: 20px;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        left: -10px;
        top: 2px;
        width: 3px;
        height: 16px;
        background: #ff5967;
      }
    }

    .desc {
      margin-top: 10px;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      line-height: 26px;
    }

    .tabs {
      margin-top: 30px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 1px solid #d6d6d6;
      height: 50px;

      .tab-item {
        font-size: 16px;
        margin-right: 45px;
        color: #333333;
        cursor: pointer;
        margin-right: 50px;
        position: relative;
        height: 100%;

        &.active {
          font-weight: bold;
          font-size: 18px;

          &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0px;
            width: 100%;
            height: 0;
            border-bottom: 3px solid #ff5967;
          }
        }

        img {
          width: 20px;
          height: 20px;
        }
      }

      .tab-item.active {
        border-bottom: none !important;
      }
    }
    .order-container {
      max-width: 1236px;
      margin: 0 auto;
      background-color: #fff;
      border-radius: 4px;

      /* 订单头部 */
      .order-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      /* 左侧标题区域 */
      .order-title-wrap {
        display: flex;
        align-items: center;
      }

      .order-title {
        font-weight: bold;
        font-size: 24px;
        color: #333333;
        margin-right: 10px;
      }

      .status-tag {
        background-color: #fff0e8;
        color: #ff8a65;
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 4px;
        margin-right: 15px;
        border-radius: 15px;
      }

      .countdown-text {
        font-size: 12px;
        color: #ff4d4f;
        display: flex;
        align-items: center;
      }

      .order-id {
        font-size: 14px;
        color: #666;
        margin-top: 8px;
        margin-bottom: 16px;
      }

      /* 右侧在线沟通 */
      .online-contact {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #666;
        cursor: pointer;
      }

      .online-contact img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }

      /* 修正后的订单信息表格 - 核心调整部分 */
      .order-info-table {
        width: 100%;
        background-color: #f9f9f9; /* 匹配原图浅灰白底色 */
        border-collapse: collapse;
        margin-bottom: 20px;
        border: none; /* 去掉外边框 */
      }

      .order-info-table tr {
        border: none;
      }

      .order-info-table td {
        padding: 15px 24px;
        border: none; /* 去掉所有单元格边框 */
        font-size: 14px;
        width: 10%; /* 平均分配10列宽度 */
        vertical-align: middle;
        /* 参数标题样式（浅灰色、小字号） */
        .param-label {
          color: #999;
          font-size: 13px;
          margin-bottom: 4px;
          display: block;
        }

        /* 参数值样式（深灰色、常规字号） */
        .param-value {
          color: #333;
          font-size: 14px;
        }
      }

      /* 操作按钮区域 */
      .order-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .btn {
        padding: 8px 20px;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
        border: 1px solid transparent;
      }

      .btn-reject {
        background-color: #fff;
        border-color: #ddd;
        color: #666;
        margin-right: 15px;
      }

      .btn-accept {
        background-color: #ff4d4f;
        color: #fff;
        border-color: #ff4d4f;
      }

      .agreement-text {
        font-size: 12px;
        color: #999;
      }

      .agreement-text a {
        color: #1890ff;
        text-decoration: none;
      }

      /* 响应式适配 */
      @media (max-width: 768px) {
        .order-header {
          flex-direction: column;
          align-items: flex-start;
        }
        .online-contact {
          margin-top: 10px;
          align-self: flex-end;
        }
        .order-info-table td {
          display: flex;
          width: 100%;
          padding: 8px 10px;
        }
        /* 手机端表格标题加冒号，更易读 */
        .order-info-table td:nth-child(odd)::after {
          content: "：";
          margin-right: 5px;
        }
        .order-actions {
          flex-direction: column;
          align-items: flex-start;
        }
        .agreement-text {
          margin-top: 10px;
        }
      }
    }
    .delivery-info {
      margin-top: 16px;
      .ico-truck {
        width: 32px;
        height: 32px;
        margin-right: 10px;
      }
      .send-delivery {
        width: 160px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #ff5967;
        border-radius: 4px 4px 4px 4px;
        cursor: pointer;
        font-size: 16px;
        color: #ffffff;
      }
    }
    .order-sample-box {
      margin-top: 20px;
      padding-bottom: 16px;
      border-bottom: 1px solid #e3e3e3;
      .add-sample {
        width: 177px;
        height: 40px;
        line-height: 40px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #ff5967;
        text-align: center;
        font-weight: 400;
        font-size: 16px;
        color: #ff5967;
        cursor: pointer;
      }
    }
    .order-sample-empty {
      padding: 30px 40px;
      text-align: center;
      .empty-img {
        width: 130px;
        height: 100px;
      }
    }
    /* 列表主容器 */
    .list-container {
      margin: 25px auto;
      background-color: #fff;
      border-radius: 8px;
      border: 1px solid #e3e3e3;
      /* 表格整体样式 */
      .fabric-table {
        width: 100%;
        border-collapse: collapse;
      }

      /* 表头样式 */
      .fabric-table thead th {
        padding: 12px 8px;
        background-color: #e3e3e3;
        text-align: left;
        font-weight: normal;
        color: #666;
        border-bottom: 1px solid #e3e3e3;
        text-align: center;
      }

      /* 表体行样式 */

      .fabric-table tbody tr {
        border-bottom: 1px solid #eee;
      }

      /* 单元格样式 */
      .fabric-table tbody td {
        padding: 12px 8px;
        vertical-align: middle;
        text-align: center;
      }

      /* 序号列宽度 */
      .fabric-table td:nth-child(1),
      .fabric-table th:nth-child(1) {
        width: 5%;
      }

      /* 图片列宽度 */
      .fabric-table td:nth-child(2),
      .fabric-table th:nth-child(2) {
        width: 15%;
      }

      /* 单价列宽度 */
      .fabric-table td:nth-child(3),
      .fabric-table th:nth-child(3) {
        width: 10%;
      }

      /* 起订量/采购周期/寄样时间列宽度 */
      .fabric-table td:nth-child(4),
      .fabric-table th:nth-child(4),
      .fabric-table td:nth-child(5),
      .fabric-table th:nth-child(5),
      .fabric-table td:nth-child(6),
      .fabric-table th:nth-child(6) {
        width: 12%;
      }

      /* 物流信息列宽度 */
      .fabric-table td:nth-child(7),
      .fabric-table th:nth-child(7) {
        width: 18%;
      }

      /* 图片样式 */
      .fabric-img-box {
        width: 96px;
        height: 96px;
        position: relative;
        margin: auto;
        .fabric-img {
          width: 96px;
          height: 96px;
          object-fit: cover;
        }
        .img-count {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 96px;
          height: 24px;
          line-height: 24px;
          background: rgba(51, 51, 51, 0.4);
          border-radius: 0px 0px 6px 6px;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }
      }

      /* 备注栏样式 */
      .remark-row td {
        background-color: #fff6f7; /* 浅粉色底色 */
        padding: 8px 12px !important;
        color: #333333;
        font-size: 13px;
        text-align: left !important;
      }

      /* 响应式适配 */
      @media (max-width: 768px) {
        .fabric-table thead {
          display: none; /* 移动端隐藏表头 */
        }
        .fabric-table tr {
          display: block;
          margin-bottom: 20px;
          border: 1px solid #eee;
        }
        .fabric-table td {
          display: block;
          width: 100%;
          padding: 8px 12px !important;
          position: relative;
        }
        /* 移动端添加列名提示 */
        .fabric-table td::before {
          content: attr(data-label);
          position: absolute;
          left: 12px;
          top: 8px;
          font-weight: bold;
          color: #999;
        }
        .fabric-table td {
          padding-left: 100px !important;
        }
        .remark-row td::before {
          content: "备注说明：";
        }
        .fabric-img {
          margin-left: 88px;
        }
      }
    }
    .delivery-big-info {
      display: flex;
      width: 100%;
      gap: 24px;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid #e3e3e3;
      /* 左侧图片区域 */
      .img-container {
        width: 35%;
        position: relative;
        border-right: 1px solid #e5e5e5;
      }

      .img-container img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }

      /* 图片右下角的14张标签 */
      .img-count {
        position: absolute;
        bottom: 0px;
        right: 0px;
        background-color: rgba(0, 0, 0, 0.7);
        color: #fff;
        font-size: 12px;
        padding: 4px 12px;
      }

      /* 右侧信息表格区域 */
      .info-container {
        width: 65%;
      }

      /* 核心表格样式 - 完全复刻原图 */
      .info-table {
        width: 100%;
        border-collapse: collapse;
        border: 1px solid #e3e3e3;
      }
      .bg-F9FAFC {
        background-color: #f9fafc;
      }
      .info-table tr {
        border-bottom: 1px solid #e3e3e3;
      }

      /* 最后一行去掉底部分隔线 */
      .info-table tr:last-child {
        border-bottom: none;
        height: 160px;
      }
      .info-table tr:last-child td {
        vertical-align: top;
      }
      .info-table td {
        padding: 14px 10px;
        vertical-align: middle;
        border-right: 1px solid #e3e3e3;
        margin-left: 10px;
      }

      /* 表格左侧标题列 */

      .info-table td:nth-child(1),
      .info-table td:nth-child(3) {
        width: 15%;
        color: #666;
        font-weight: normal;
      }
      .info-table td:last-child {
        border-right: none;
      }

      /* 表格内容列 */
      .info-table td:nth-child(2),
      .info-table td:nth-child(4) {
        color: #333;
        width: 35%;
      }

      /* 备注说明单元格跨列样式 */
      .info-table .remark-cell {
        padding-top: 12px;
        padding-bottom: 12px;
      }

      /* 响应式适配 - 移动端自动转为上下布局 */
      @media (max-width: 768px) {
        .container {
          flex-direction: column;
        }
        .img-container {
          width: 100%;
          height: 280px;
          border-right: none;
          border-bottom: 1px solid #e5e5e5;
        }
        .info-container {
          width: 100%;
        }
        .info-table td {
          padding: 10px 12px;
        }
      }
    }

    .detail-container {
      width: 100%;
      display: flex;
      gap: 24px;
      margin-top: 30px;
      /* 左侧图片区域 */
      .fabric-image {
        height: 300px;
        width: 300px;
      }

      .fabric-image img {
        width: 100%;
        height: auto;
        display: block;
        object-fit: cover;
        height: 300px;
      }

      /* 右侧信息区域 */
      .fabric-details {
        flex: 1;
        color: #333;
        font-size: 14px;
        background: #f8f9fb;
        padding: 24px;
      }

      /* 面料参数表格样式 - 匹配图片中的无边框、三列布局 */
      .params-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 25px;
      }

      .params-table td {
        padding: 8px 0;
        vertical-align: top;
        width: 33.333%;
      }

      /* 参数标题样式（浅灰色、小字号） */
      .param-label {
        color: #999;
        font-size: 13px;
        margin-bottom: 4px;
        display: block;
      }

      /* 参数值样式（深灰色、常规字号） */
      .param-value {
        color: #333;
        font-size: 14px;
      }

      /* 使用说明标题样式 */
      .usage-title {
        font-weight: bold;
        color: #333;
        font-size: 14px;
        margin-bottom: 8px;
        display: block;
      }
      .usage-section {
        border-top: 1px solid #e3e3e3;
        padding-top: 22px;
      }
      /* 使用说明内容样式 */
      .usage-content {
        color: #666;
        font-size: 14px;
        line-height: 1.8;
      }
    }
    .design-img-list {
      gap: 20px;
      margin-top: 20px;

      .item {
        position: relative;
        width: 186px;
        cursor: pointer;

        .image {
          width: 186px;
          height: 186px;
          object-fit: cover;
          border: 1px solid #ebedf2;
        }

        .mask {
          display: none;
        }

        &:hover {
          .mask {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            width: 186px;
            height: 186px;
            z-index: 10;
            background: rgba(0, 0, 0, 0.35);
            border-radius: 10px;

            .icon-mag {
              position: absolute;
              width: 32px;
              height: 32px;
              top: calc(50% - 16px);
              left: calc(50% - 16px);
              transform: translate(-50% -50%);
            }

            .icon-download {
              position: absolute;
              width: 20px;
              height: 20px;
              bottom: 10px;
              right: 10px;
            }
          }
        }

        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }

    .file-item {
      height: 76px;
      background: #f8f9fb;
      border-radius: 4px;
      margin-bottom: 16px;
      padding: 0 12px;
      .icon-doc {
        width: 42px;
        height: 42px;
      }
      .download-img {
        width: 20px;
        height: 20px;
      }

      .download {
        font-weight: 400;
        font-size: 14px;
        color: #0d99ff;
        margin-left: 5px;
      }
    }
  }
}
.agree-content {
  overflow-y: scroll;
  height: 100%;
  max-height: max(30vh, 70vh); // 最大720px，最小占85%视口高
  padding: 30px 30px 0 30px;
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;
  }
}
</style>
